import * as ActionName from '../action-names';
import InitialState from '../initial-state';

export default function listViewReducer(state = InitialState.getState().listView, action) {
  switch (action.type) {

    case ActionName.LOAD_LIST_VIEW_SUCCESS:
      return Object.assign({}, state, { groupDetails: action.data.groupDetails, eventGroups: action.data.eventGroups });
    case ActionName.CLEAR_LIST_VIEW_DATA:
      return Object.assign({}, state, { groupDetails: null, eventGroups: [] });
    case ActionName.LOAD_LIST_VIEW_HIGHLIGHTS_SUCCESS:
      return Object.assign({}, state, { highlightedEvents: action.data });
    default:
      return state;
  }
}
